module.exports = __webpack_public_path__ + "assets/media/group-dots-about.a105bc60.svg";